/* eslint-disable react/jsx-wrap-multilines */
import React, { useEffect } from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { useHistory, useLocation } from 'react-router';
import { reset } from 'redux-form';
import { getProductInvoiceAction, sendInvoiceAction, setProductInvoiceAction } from './actions';
import { getIsModalShownSelector, getIsFormSendingSelector, getIsProductInvoiceLoadingSelector } from './selectors';
import { FORM_NAME } from './constants';
import ModalFooterButtons from '../../semantic-ui/components/modal-window/modal-footer-buttons';
import { ModalWindow } from '../../semantic-ui/components/modal-window';
import { useInjectSaga } from '../../utils/injectSaga';
import { useInjectReducer } from '../../utils/injectReducer';
import reducer from './reducer';
import saga from './saga';
import { removeModalQuery } from '../../utils/removeModalQuery';
import { ProductInvoiceForm } from './components/product-invoice-form';
import closeModal from '../../utils/closeModal';

const ProductInvoiceModalWrapper = ({
	onGetProductInvoice,
	isModalShown,
	onSendInvoice,
	onResetForm,
	isFormSending,
	onSetProductInvoice,
	isProductInvoiceLoading,
}) => {
	if (!isModalShown) return null;
	useInjectSaga({ key: 'productInvoiceModalSaga', saga });
	useInjectReducer({ key: 'productInvoiceModalReducer', reducer });

	const { search, pathname } = useLocation();

	const query = new URLSearchParams(search);

	const history = useHistory();

	useEffect(() => {
		if (isModalShown) {
			onGetProductInvoice(query.get('id'));
		}
	}, [isModalShown]);

	const handleModalCancel = () => {
		query.set('modal', 'reqs_details');
		onResetForm(FORM_NAME);
		onSetProductInvoice(null);
		history.push(`${pathname}?${query}`);
	};

	const handleModalClose = () => {
		closeModal(query);
		onResetForm(FORM_NAME);
		onSetProductInvoice(null);
		history.push(`${pathname}?${query}`);
	};

	const handleFormSubmit = async () => {
		onSendInvoice({
			redirect: handleModalCancel,
			id: query.get('id'),
			searchQuery: removeModalQuery(query.toString()),
		});
	};

	const handleKeyDown = e => {
		if (e.key === 'Enter' && e.shiftKey === false) {
			handleFormSubmit();
		}
	};

	return (
		<ModalWindow
			isModalShown={isModalShown}
			onKeyDown={handleKeyDown}
			onClose={handleModalClose}
			headerText="Изменить № товарной накладной"
			modalContent={<ProductInvoiceForm />}
			style={{ width: '895px' }}
			actionButtons={[{ type: 'close', onClick: handleModalClose, text: 'product_invoice' }]}
			footerButtons={
				<ModalFooterButtons
					rightButtons={[
						{
							onClick: handleFormSubmit,
							text: 'Сохранить',
							color: 'success',
							loading: isFormSending,
							disabled: isFormSending || isProductInvoiceLoading,
						},
						{
							onClick: handleModalCancel,
							text: 'Закрыть',
							color: 'secondary',
							disabled: isFormSending,
						},
					]}
				/>
			}
		/>
	);
};

const mapStateToProps = createStructuredSelector({
	isModalShown: getIsModalShownSelector(),
	isFormSending: getIsFormSendingSelector(),
	isProductInvoiceLoading: getIsProductInvoiceLoadingSelector(),
});

const mapDispatchToProps = {
	onGetProductInvoice: getProductInvoiceAction,
	onSendInvoice: sendInvoiceAction,
	onResetForm: reset,
	onSetProductInvoice: setProductInvoiceAction,
};

const ProductInvoiceModal = connect(mapStateToProps, mapDispatchToProps)(ProductInvoiceModalWrapper);

ProductInvoiceModalWrapper.propTypes = {
	onGetProductInvoice: PropTypes.func.isRequired,
	onSendInvoice: PropTypes.func.isRequired,
	isFormSending: PropTypes.bool.isRequired,
	isModalShown: PropTypes.bool.isRequired,
	onResetForm: PropTypes.func.isRequired,
	isProductInvoiceLoading: PropTypes.bool.isRequired,
	onSetProductInvoice: PropTypes.func.isRequired,
};

export default ProductInvoiceModal;
